const CLEAR_AUTH_ACTION_TYPE = "auth/clearAuthData";

export { CLEAR_AUTH_ACTION_TYPE };